/**
 * replicated object of pagination instanse(interal model of third party pagination package),
 * Reason for replication : some of the proeprties are optional in pagination instance but we required all the property from the user.
 * So created a wrapper around it.
 */
export class PaginationInstanceModel {
  id: string;
  itemsPerPage: number;
  currentPage: number;
  totalItems: number;

  constructor(id: string, itemsPerPage: number, currentPage: number, totalItems: number) {
    this.id = id;
    this.itemsPerPage = itemsPerPage;
    this.currentPage = currentPage;
    this.totalItems = totalItems;
  }
}
